import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "base-menu-item__label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["base-menu-item", _ctx.$attrs.class])
  }, [
    (_ctx.hasActivator)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), _mergeProps({
          key: 0,
          ref: "tag"
        }, { ..._ctx.omit(_ctx.$attrs, ['class']), ..._ctx.tagProps }, {
          class: ["base-menu-item__activator", { 'base-menu-item__activator--is-clickable': _ctx.isClickable }]
        }), {
          default: _withCtx(() => [
            (_ctx.hasLabel)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  (_ctx.label)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.label), 1)
                      ], 64))
                    : _renderSlot(_ctx.$slots, "label", { key: 1 })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 3
        }, 16, ["class"]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}